export const HOME_PACKAGE_SLOT_COUNT = 4;
export const HOME_PACKAGE_CYCLE_MS = 8000;

export const getCycledPackages = (packages = [], offset = 0, slotCount = HOME_PACKAGE_SLOT_COUNT) => {
  if (!Array.isArray(packages) || packages.length === 0) return [];
  if (packages.length <= slotCount) return packages;
  const start = ((offset % packages.length) + packages.length) % packages.length;
  return Array.from({ length: slotCount }, (_, index) => (
    packages[(start + index) % packages.length]
  ));
};
